import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DiaryEventGroup } from "../../models/diary-event-group"
import { DiaryEventKeySet } from "../../utils/diary-event-key-set"

@Component({
  selector: 'mojo-calendar-year-view',
  templateUrl: './calendar-year-view.component.html',
  styleUrls: ['./calendar-year-view.component.scss']
})
export class CalendarYearViewComponent implements OnInit {
  allAvailableMonths: Array<any> = [];
  @Output() onItemClicked = new EventEmitter<any>();
  @Input() date: Date;

  private _diaryEvents: DiaryEventGroup[];
  private _diaryEventKeySet: DiaryEventKeySet = new DiaryEventKeySet([]);

  @Input() set diaryEvents(value: DiaryEventGroup[]) {
    this._diaryEvents = value;
    this._diaryEventKeySet = new DiaryEventKeySet(this._diaryEvents);
  }

  get diaryEvents(): DiaryEventGroup[] {
    return this._diaryEvents;
  }

  hasEvents(nonStandardMonthNumber: number): boolean {
    return this._diaryEventKeySet.hasEventsInMonth(nonStandardMonthNumber - 1);
  }

  constructor() {
    this.allAvailableMonths = this.getMonths();
  }

  itemClicked(item) {
    this.onItemClicked.emit(item.value);
  }

  ngOnInit() {
  }

  getMonths(): Array<any> {
    return [
      { text: 'January', value: 1 },
      { text: 'February', value: 2 },
      { text: 'March', value: 3 },
      { text: 'April', value: 4 },
      { text: 'May', value: 5 },
      { text: 'June', value: 6 },
      { text: 'July', value: 7 },
      { text: 'August', value: 8 },
      { text: 'September', value: 9 },
      { text: 'October', value: 10 },
      { text: 'November', value: 11 },
      { text: 'December', value: 12 },
    ];
  }
}
